var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M13.53 4.47l7 7c.3.3.3.77 0 1.06l-7 7a.75.75 0 01-1.06-1.06l5.72-5.72H4a.75.75 0 110-1.5h14.19l-5.72-5.72a.75.75 0 011.06-1.06z"}})}
var staticRenderFns = []

export { render, staticRenderFns }